import { cva } from 'class-variance-authority';

export const popoverContentVariants = cva(
  [
    'bg-neutral border border-neutral-muted rounded-lg p-4 shadow max-w-[320px] overflow-hidden',
    'origin-[var(--transform-origin)] transition-[opacity,transform] duration-150 ease-out data-[starting-style]:opacity-0 data-[starting-style]:scale-95 data-[ending-style]:opacity-0 data-[ending-style]:scale-95',
  ].join(' ')
);

export const popoverArrowVariants = cva(
  'fill-neutral [&>path]:stroke-muted'
);
